import React from 'react';
import { injectIntl, FormattedHTMLMessage, IntlShape } from 'react-intl';
import { Button, Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import CustomModal from '../../../components/CustomModal';
import { ReactComponent as EditModalAlertSvg } from '../../../assets/icons/edit_confirmation_modal_alert.svg';

import '../styles.css';

type Props = {
  intl: IntlShape,
  open: boolean,
  onClose: () => void,
  onConfirm: () => void,
};

const EditWarningModal: React.FC<Props> = ({
  intl,
  open,
  onClose,
  onConfirm,
}) => (
  <CustomModal
    title=""
    open={open}
    onClose={() => { onClose(); }}
    height="100%"
    width="50%"
  >
    <Box id="warning-modal">
      <Box>
        <Box display="flex" flexDirection="column" alignItems="center" my="40px" textAlign="center">
          <Box mb={4} mt={-4}>
            <EditModalAlertSvg />
          </Box>
          <Typography variant="h6" style={{ fontWeight: 700, margin: '0 110px' }}>
            {intl.formatMessage({ id: 'forms.edit.warning.title' })}
          </Typography>
          <Typography variant="body2" style={{ margin: '10px 80px' }}>
            {intl.formatMessage({ id: 'forms.edit.impact.description' })}
          </Typography>
          <Typography variant="body2" style={{ margin: '10px 60px' }}>
            {intl.formatMessage({ id: 'forms.edit.inconsistency.note' })}
          </Typography>
          <Typography variant="body2" style={{ margin: '10px 60px' }}>
            <FormattedHTMLMessage
              id="forms.edit.recommendation.strong"
            />
          </Typography>
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" gridGap="1.5rem" className="modal-footer">
        <Button
          onClick={() => { onClose(); }}
          variant="outlined"
          style={{ minWidth: 200 }}
        >
          {intl.messages['utils.cancel']}
        </Button>
        <Button
          onClick={() => onConfirm()}
          variant="contained"
          style={{ minWidth: 200 }}
        >
          {intl.messages['forms.edit.warning.button.confirm']}
        </Button>
      </Box>
    </Box>
  </CustomModal>
);

EditWarningModal.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    messages: PropTypes.func.isRequired,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

EditWarningModal.defaultProps = {};

export default injectIntl(EditWarningModal);
